import { useState } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  Box,
  Stack
} from '@chakra-ui/react'
import { Capacitor } from '@capacitor/core'
import { motion } from 'framer-motion'
import {
  authSelectors,
  deleteProfileItem,
  handleOpenModal,
  markersSelectors,
  setBlogParent,
  setComments,
  setConnReqData,
  setHideNotification,
  setNotificationSectionPage,
  setOpenFriendRequest,
  setPosts,
  stopMap,
  usersSelectors,
  chatCredentialsSelectors,
  getAdminNotifications,
  getBlockedRequest,
  getFriendsNotifications,
  setAdminNotifRequest,
  setUserSectionPage,
  setBlogRepostData,
  setChatSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents
} from 'store'
import {
  MODAL_SECTION,
  NotificationSections,
  SUCCEEDED
} from 'utils/constants'
import {
  isAuth,
  isNotMobile,
  showCoordParams
} from 'utils/helpers'
import { COLORS } from 'utils/styles'

import { NotifBarDisplay } from 'components/Footer/NotifBarDisplay'
import { NotificationPanel } from './NotificationPanel'

const MotionBox = motion(Box)

export const Footer = () => {
  const { mapStop } = useSelector(markersSelectors)
  const { signInStatus } = useSelector(authSelectors)
  const {
    meXmppIsOnline,
    meXmppProblem
  } = useSelector(chatCredentialsSelectors)
  const {
    activeProfile,
    getBlockedRequestStatus,
    getFriendsNotificationsStatus,
    getAdminNotificationsStatus,
    isBlogFormOpen,
    notificationSectionPage
  } = useSelector(usersSelectors)

  const dispatch = useDispatch()

  const [showNotifications, setShowNotifications] = useState(false)
  const [runClosingAnimation, setRunClosingAnimation] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const isBlogForMobile = () => isBlogFormOpen && !isNotMobile()

  const clearOptions = (isNotifModalOpen) => {
    if (!isNotifModalOpen) {
      dispatch(setOpenFriendRequest(null))
    }

    dispatch(setConnReqData([]))
    setTimeout(() => sessionStorage.removeItem('id'), 800)
    localStorage.removeItem('openedNotifId')
    localStorage.setItem('is-notif-modal-open', 'false')
    dispatch(handleOpenModal({ isOpen: isNotifModalOpen, section: MODAL_SECTION?.RightSection }))
    setSearchParams({})

    dispatch(setHideNotification(false))
    setRunClosingAnimation(!isNotifModalOpen)
    if (!isNotifModalOpen) {
      dispatch(setNotificationSectionPage('clear'))
      showCoordParams(setSearchParams)
    }
  }

  return (
    <Stack
      position="relative"
      background={COLORS.gold}
      width="100%"
      height="50px"
      className="notificationBar"
      data-name="notificationBar"
    >
      <MotionBox
        initial={{ y: 0 }}
        animate={{
          y: isBlogForMobile() && !Capacitor.isNativePlatform() ? 50 : 0
        }}
        transition={{
          type: 'tween',
          duration: 0.8
        }}
        position="absolute"
        zIndex={isAuth() ? 1401 : 1392}
        display="flex"
        top="50%"
        left="50%"
        style={{
          translateX: '-50%',
          translateY: '-50%'
        }}
        cursor="pointer"
        id="open-notif-panel"
        onClick={() => {
          sessionStorage.removeItem('openProfileAfterAnimation')
          sessionStorage.removeItem('openEventAfterAnimation')
          document.querySelector('#custom-popup-overlay')?.click()
          document.querySelector('#custom-popup-overlay-event')?.click()
          dispatch(setUserSectionPage('clear'))
          dispatch(setChatSectionPage('clear'))
          dispatch(setNotificationSectionPage('clear'))
          dispatch(setOpenPopupBlogs(false))
          dispatch(setOpenPopupEvents(false))
          dispatch(setBlogRepostData([]))
          dispatch(setHideNotification(false))

          dispatch(setNotificationSectionPage({
            key: NotificationSections.NOTIFICATIONS,
            title: 'Notifications'
          }))

          if (
            meXmppIsOnline
            || meXmppProblem != null
          ) {
            dispatch(setAdminNotifRequest(null))

            if (getAdminNotificationsStatus !== 'PENDING') {
              dispatch(getAdminNotifications()).then(() => {
                dispatch(deleteProfileItem())
                setShowNotifications(true)
              })
            }

            if (getFriendsNotificationsStatus !== 'PENDING') {
              dispatch(getFriendsNotifications())
            }

            if (getBlockedRequestStatus !== 'PENDING') {
              dispatch(getBlockedRequest(activeProfile?.id))
            }
          }

          dispatch(stopMap(!mapStop))
          dispatch(setConnReqData([]))
          dispatch(setBlogParent([]))
          dispatch(setPosts([]))
          dispatch(setComments([]))
          localStorage.setItem('isNotifOpen', 'true')
          clearOptions(true)
        }}
      >
        {
          isAuth()
            ? <NotifBarDisplay notificationSectionPage={notificationSectionPage} />
            : (
              <Box
                as="button"
                height="40px"
                padding="10px 61px"
                borderRadius="5px"
                backgroundColor="white"
                width="366px"
                fontSize="20px"
                lineHeight="22.5px"
                boxShadow="0 3px 3px 0 rgba(108, 122, 137, .7)"
                sx={{
                  '@media (max-width: 768px)': {
                    width: '385px'
                  },
                  '@media (max-width: 480px)': {
                    width: '306px',
                    fontSize: '15px'
                  },
                  '@media (max-width: 390px)': {
                    width: '266px',
                    padding: '10px 45px',
                    fontSize: '15px'
                  }
                }}
              >
                <center>
                  {
                    sessionStorage.getItem('postId')
                    && signInStatus !== SUCCEEDED
                    && !isAuth()
                      ? 'Get Connected! Sign Up...'
                      : 'Instructions'
                  }
                </center>
              </Box>
            )
        }
      </MotionBox>

      <NotificationPanel
        runClosingAnimation={runClosingAnimation}
        clearOptions={clearOptions}
        setShowNotifications={setShowNotifications}
        showNotifications={showNotifications}
      />
    </Stack>
  )
}
